import { StyledVoiceSelectOption } from './VoiceSelectOption.styled';
import { useAudio } from '../../providers/AudioContext';

const VoiceSelectOption = ({ option, isSelected = false, onClick }) => {
  const { playSFX } = useAudio();

  return (
    <StyledVoiceSelectOption $selected={isSelected} onClick={onClick} onMouseEnter={() => playSFX('hover')}>
      <div>{option.name}</div>
      {isSelected && <img src='/assets/done.svg'/>}
    </StyledVoiceSelectOption>
  );
};

export default VoiceSelectOption;
